function newsesScript() {
	
	var $newsCalendarItem = document.querySelectorAll('.date-sorter-name'),
		$newsCalendarMonth = document.querySelectorAll('.date-sorter__month')[0],
		$dateSorterAllNews = document.querySelector('.date-sorter__all-news'),
		$mainNewsItem = $('.main-news-item');

	for(var i=0; i < $newsCalendarItem.length; i++) {
		$newsCalendarItem[i].addEventListener('click', function(e){
			if(!$('.list-news-month').hasClass('new-aside-item')) {
				e.preventDefault();

			}

			var $self = this,
				year = $self.getAttribute('data-year'),
				month = $self.getAttribute('data-month');

			for(var i=0; i < $newsCalendarItem.length; i++) {
				$newsCalendarItem[i].classList.remove('active');
			}

			$self.classList.add('active');

			$mainNewsItem.each(function(){
				$(this).fadeOut(400);
			});

			if($newsCalendarMonth) {

				setTimeout(function(){
					$('.main-news-item[data-year='+year+'][data-month='+month+']').fadeIn(400).addClass('active');
				}, 600);

			} else {

				setTimeout(function(){
					$('.main-news-item[data-year='+year+']').fadeIn(400).addClass('active');
				}, 600);

			}

		});
	}

	if($dateSorterAllNews) {

		$dateSorterAllNews.addEventListener('click', function(e) {
			e.preventDefault();

			for(var i=0; i < $newsCalendarItem.length; i++) {
				$newsCalendarItem[i].classList.remove('active');
			}

			$mainNewsItem.fadeIn(400).addClass('active');
		});

	}

};

module.exports = newsesScript;